export const getPageName = (app: string) => {
	const hash = window.location.hash;
	if (hash.length > 2) {
		return `${app}:${window.location.hash
			.replace('#/', '')
			.split('/')
			.join(':')}`;
	} else {
		return `${app}:home`;
	}
};

export const getSubSection = (pageName: string) =>
	pageName.split(':').slice(3)[0] || 'home';

export const getSubSectionChild = (pageName: string) =>
	pageName.split(':').slice(3)[1] || '';
